import {
  getFrontCategorie,
  getGetFrontCategorieQueryOptions,
  type CategoriaDTO,
} from '@framework/api-client';
import {
  AsyncSelectInput,
  type IBaseAsyncSelectInputProps,
} from '@framework/form';

export interface IFrontCategoryAsyncSelectInputProps
  extends IBaseAsyncSelectInputProps {}

export function FrontCategoryAsyncSelectInput(
  props: IFrontCategoryAsyncSelectInputProps,
) {
  return (
    <AsyncSelectInput
      queryFn={getFrontCategorie}
      initialParams={{ ordinamenti: ['etichetta'], attivaNascondiFiltro: true }}
      queryOptions={getGetFrontCategorieQueryOptions}
      searchByField="text"
      asOption={(category: CategoriaDTO) => ({
        value: category.id!,
        label: category.etichetta!,
      })}
      {...props}
    />
  );
}
